"use client";
import { useEffect } from "react";
import { useAuthStore } from "@/stores/auth-store";

export function AuthHydrator() {
  const setUser = useAuthStore((s) => s.setUser);

  useEffect(() => {
    let alive = true;
    fetch("/api/auth/me", { credentials: "include" })
      .then((r) => r.json())
      .then((d) => { if (alive) setUser(d.user ?? null); })
      .catch(() => { if (alive) setUser(null); });
    return () => { alive = false; };
  }, [setUser]);

  return null;
}